import { Checkbox } from "@omnia/shared/react/checkbox";
import { classes } from "@omnia/shared/react/react";
import { useCallback } from "react";
import { State } from "../../state";
import { EditorUser, GenericProps } from "../../types";
import { useSetPermissions } from "./hooks";
import { CroppingGroup } from "./types";

interface Props extends GenericProps {
    members: EditorUser[]
    group: CroppingGroup
}

export function GroupPermissions({ state, dispatch, members, group }: Props) {

    const stateProvider = useGroupStateProvider(state, group)

    const update = useSetPermissions(dispatch)

    return <>

        <div className="group name" style={{ gridColumn: 1 }}>
            <span>
                {group.label}
            </span>
        </div>

        {
            members.map((user, index) => {

                const state = user.restrictCroppingAccess
                    ? stateProvider(user.userId)
                    : true

                const disabled = !user.restrictCroppingAccess

                return <div
                    key={user.userId}
                    className={classes("group user", disabled && "disabled", (index === (members.length - 1) && "last"))}
                    style={{ gridColumn: (index + 2) }}>

                    {
                        disabled
                            ? <i className="fa-regular fa-check"></i>
                            : <Checkbox
                                indeterminate={state === undefined}
                                checked={state ?? true}
                                setChecked={c => update(user.userId, group.cropping, c)}
                                disabled={disabled}
                            />
                    }

                </div>
            })

        }
    </>

}

function useGroupStateProvider({ users: { edits } }: State, { cropping }: CroppingGroup) {

    return useCallback((userId: number) => {

        const permissions = edits.find(u => u.userId === userId)?.croppingPermissions ?? {}

        const set = new Set(
            cropping.map(c => permissions[c.croppingId]?.authorized ?? true)
        )

        return set.size > 1
            ? undefined
            : set.has(true)

    }, [edits, cropping])

}